<template>
  <div class="my_button_set m-lr-11">
    <div class="func_panel_item_wrap panel_item_radio">
      <p class="tips_left">
        <el-popover
          v-if="iconIsShow == 'left'"
          placement="top-start"
          popper-class="popover_style"
          :width="tipsWidth"
          trigger="hover"
          :content="tips"
          transition="zoom"
        >
          <span
            class="icon_info"
            slot="reference"
          >?</span>
        </el-popover>
      </p>
      <p
        v-if="title"
        class="panel_item_title title"
        :class="iconIsShow != 'left' ? 'no_icon': ''"
        :style="{
          width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth
        }"
      >
        <span v-text="title"></span>
      </p>

      <p class="panel_item_content">
          <my_input_number
            titleWidth="0"
            :value.sync="width_value_display"
            :min="0"
            :max="widthMax"
            class='line_part'
            @change="(e)=>{setMargin(e,'widthValue')}"
          ></my_input_number>
            <i class="iconfont line_part icon_line" @click="changeType" :class="lock_type == 'true'?'icon-lock':'icon-unlock'"></i>
          <my_input_number
            titleWidth="0"
            :value.sync="height_value"
            :min="0"
            class='line_part'
            @change="(e)=>{setMargin(e,'heightValue')}"
          ></my_input_number>
          <el-popover
            v-if="iconIsShow == 'right'"
            placement="top-start"
            popper-class="popover_style"
            :width="tipsWidth"
            trigger="hover"
            :content="tips"
            transition="zoom"
          >
            <span
              class="icon_info icon_info_right"
              slot="reference"
            >?</span>
          </el-popover>
      </p>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_button_set',
  props: {
    title: { // 组件的标题
      type: String,
      default: ''
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    heightValue: { // 高度值
      default: '0'
    },
    widthValue: { // 宽度值
      default: '0'
    },
    lockType: { // 锁定状态
      default: 'false'
    },
    iconIsShow: { // 图标位置（'' 不显示 left 左边显示 right 右边显示）
      type: String,
      default: ''
    },
    option: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
    tips: { // 图标提示信息
      type: String,
      default: ''
    },
    defaultIsShow: { // 默认设置是否显示
      type: String,
      default: 'true'
    },
    hiddenIsShow: { // 隐藏设置是否显示
      type: String,
      default: 'true'
    },
    selfIsShow: { // 自定义设置是否显示
      type: String,
      default: 'true'
    },
    defaultTitle: { // 默认设置标题
      type: String,
      default: i18n.t('view_back_top_edit_103')
    },
    hiddenTitle: { // 隐藏设置标题
      type: String,
      default: i18n.t('view_back_top_index_105')
    },
    selfTitle: { // 自定义设置标题
      type: String,
      default: i18n.t('view_back_top_edit_102')
    },
    defaultIsDisabled: { // 默认设置是否禁用
      type: String,
      default: 'false'
    },
    hiddenIsDisabled: { // 隐藏设置是否禁用
      type: String,
      default: 'false'
    },
    selfIsDisabled: { // 自定义设置是否禁用
      type: String,
      default: 'false'
    },
    tipsWidth: {
      type: String,
      default: '220'
    },
    box_width:{
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      height_value: this.heightValue,
      weight_value: this.widthValue,
      lock_type:this.lockType,
      height_value_display:0,
      width_value_display:0,
      margin_left:this.widthValue.marginLeft,
      margin_right:this.widthValue.marginRight,
    }
  },
  mounted () {
  },
  watch: {
    height_value (val, oldVal) { // 数据双向绑定
      this.$emit('update:heightValue', val);
    },
    'heightValue' (val) { // 数据双向绑定
      this.height_value = val
    },
    weight_value (val, oldVal) { // 数据双向绑定
      this.$emit('update:widthValue', val);
    },
    'widthValue' (val) { // 数据双向绑定
      this.weight_value = val
    },
    lock_type (val, oldVal) { // 数据双向绑定
      this.$emit('update:lockType', val);
    },
    'lockType' (val) { // 数据双向绑定
      this.lock_type = val
    }
  },
  computed: {
    widthMax(){
      return this.box_width_calculation()
    }
  },
  methods: {
    changeType(){
      if(this.lock_type === 'true'){
        this.lock_type = 'false'
        this.lock_height_value = 0
        this.lock_width_value = 0
      }else{
        this.lock_type = 'true'
        this.lock_height_value = parseInt(this.height_value)
        this.lock_width_value = parseInt(this.width_value_display)
      }
    },
    box_width_calculation(){
      let r = document.documentElement.clientWidth || document.body.clientWidth;
      if(this.box_width > 0){
        r = this.box_width;
      }else if(this.$store.state.app.module_Data){
        r = $(`#u${this.$store.state.app.module_Data.widgets_id}`).parent().width();
      }
      // console.log(r)
      return r
    },
    setMargin (value, key) {
      let percentage = '0%'
      if (value !== 0 && key == 'widthValue') {
          percentage = (100 - parseFloat(value / this.box_width_calculation() * 100).toFixed(4))/2 + '%'
      }
      if(this.lock_type == 'true'){
        if(key == 'heightValue'){
          let widthChange = value*(this.lock_width_value/this.lock_height_value)
          let data = (100 - parseFloat(widthChange / this.box_width_calculation() * 100).toFixed(4))/2 + '%'
          this.weight_value.marginLeft=data
          this.weight_value.marginRight=data
          this.$emit('update:widthValue', this.weight_value)
          this.width_value_display = Math.round(this.widthMax*(1 - parseFloat(this.weight_value.marginLeft)/100 - parseFloat(this.weight_value.marginRight)/100))
        }else{
          let heightChange = value*(this.lock_height_value/this.lock_width_value)
          this.height_value = Math.round(heightChange)
        }
      }
      if(key == 'heightValue'){
        // this.$emit('update:' + key, percentage)
      }else{
        this.weight_value.marginLeft=percentage
        this.weight_value.marginRight=percentage
        this.$emit('update:' + key, this.weight_value)
      }
    }
  },
  mounted(){
    this.width_value_display = Math.round(this.widthMax*(1 - parseFloat(this.weight_value.marginLeft)/100 - parseFloat(this.weight_value.marginRight)/100))
    this.height_value = Math.round(parseFloat(this.height_value))
    if(this.lock_type == 'true'){
      this.lock_height_value = parseInt(this.height_value)
      this.lock_width_value = parseInt(this.width_value_display)
    }

  }
}
</script>

<style scoped type="text/css" lang="scss">
.my_button_set {
  position: relative;
  margin-bottom: 12px;
  .tips_left {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 34px;
    position: absolute;
    margin-left: -20px;
    .icon_info {
      border: 1px solid #cfd3db;
      color: #cfd3db;
      width: 18px;
      font-size: 13px;
      height: 18px;
      display: inline-block;
      border-radius: 50%;
      text-align: center;
      line-height: 18px;
      cursor: pointer;
    }
    .icon_info_right {
      margin-left: -10px;
    }
  }
  .line_part{
    display: inline-block;
    vertical-align: top;
    &.icon_line{
      width: 20px;
      margin: 0 5px;
      cursor: pointer;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_button_set/index.vue